const countries = [
{ name: "Afghanistan", iso2: "af", dialCode: "93", minLength: 9, maxLength: 9 },
{ name: "Albania", iso2: "al", dialCode: "355", minLength: 9, maxLength: 9 },
{ name: "Algeria", iso2: "dz", dialCode: "213", minLength: 9, maxLength: 9 },
{ name: "Andorra", iso2: "ad", dialCode: "376", minLength: 6, maxLength: 6 },
{ name: "Angola", iso2: "ao", dialCode: "244", minLength: 9, maxLength: 9 },
{ name: "Argentina", iso2: "ar", dialCode: "54", minLength: 10, maxLength: 11 },
{ name: "Armenia", iso2: "am", dialCode: "374", minLength: 8, maxLength: 8 },
{ name: "Australia", iso2: "au", dialCode: "61", minLength: 9, maxLength: 9 },
{ name: "Austria", iso2: "at", dialCode: "43", minLength: 10, maxLength: 11 },
{ name: "Azerbaijan", iso2: "az", dialCode: "994", minLength: 9, maxLength: 9 },

{ name: "Bangladesh", iso2: "bd", dialCode: "880", minLength: 10, maxLength: 10 },
{ name: "Bahrain",iso2: "bh",dialCode: "973",minLength: 8,maxLength: 8},
{ name: "Belgium", iso2: "be", dialCode: "32", minLength: 9, maxLength: 9 },
{ name: "Brazil", iso2: "br", dialCode: "55", minLength: 10, maxLength: 11 },
{ name: "Bulgaria", iso2: "bg", dialCode: "359", minLength: 8, maxLength: 9 },
{ name: "Canada", iso2: "ca", dialCode: "1", minLength: 10, maxLength: 10 },
{ name: "China", iso2: "cn", dialCode: "86", minLength: 11, maxLength: 11 },
{ name: "Colombia", iso2: "co", dialCode: "57", minLength: 10, maxLength: 10 },
{ name: "Croatia", iso2: "hr", dialCode: "385", minLength: 9, maxLength: 9 },
  { name: "Cyprus", iso2: "cy", dialCode: "357", minLength: 8, maxLength: 10 },
{ name: "Czech Republic", iso2: "cz", dialCode: "420", minLength: 9, maxLength: 9 },

{ name: "Denmark", iso2: "dk", dialCode: "45", minLength: 8, maxLength: 8 },
{ name: "Egypt", iso2: "eg", dialCode: "20", minLength: 10, maxLength: 10 },
  { name: "Estonia", iso2: "ee", dialCode: "372", minLength: 7, maxLength: 11 },
{ name: "Finland", iso2: "fi", dialCode: "358", minLength: 9, maxLength: 10 },
{ name: "France", iso2: "fr", dialCode: "33", minLength: 9, maxLength: 9 },
{ name: "Germany", iso2: "de", dialCode: "49", minLength: 10, maxLength: 11 },
{ name: "Ghana", iso2: "gh", dialCode: "233", minLength: 9, maxLength: 9 },
{ name: "Greece", iso2: "gr", dialCode: "30", minLength: 10, maxLength: 10 },

{ name: "Hong Kong", iso2: "hk", dialCode: "852", minLength: 8, maxLength: 8 },
{ name: "Hungary", iso2: "hu", dialCode: "36", minLength: 9, maxLength: 9 },
{ name: "Iceland", iso2: "is", dialCode: "354", minLength: 7, maxLength: 7 },
{ name: "India", iso2: "in", dialCode: "91", minLength: 10, maxLength: 10 },
{ name: "Indonesia", iso2: "id", dialCode: "62", minLength: 9, maxLength: 12 },
{ name: "Iran", iso2: "ir", dialCode: "98", minLength: 10, maxLength: 10 },
{ name: "Ireland", iso2: "ie", dialCode: "353", minLength: 9, maxLength: 9 },
{ name: "Israel", iso2: "il", dialCode: "972", minLength: 9, maxLength: 9 },
{ name: "Italy", iso2: "it", dialCode: "39", minLength: 9, maxLength: 10 },

{ name: "Japan", iso2: "jp", dialCode: "81", minLength: 10, maxLength: 10 },
{ name: "Kenya", iso2: "ke", dialCode: "254", minLength: 9, maxLength: 9 },
{ name: "Kuwait", iso2: "kw", dialCode: "965", minLength: null, maxLength: null },
{ name: "Latvia", iso2: "lv", dialCode: "371", minLength: 8, maxLength: 8 },
{ name: "Lithuania", iso2: "lt", dialCode: "370", minLength: 8, maxLength: 12 },
{ name: "Luxembourg", iso2: "lu", dialCode: "352", minLength: 9, maxLength: 12 },
{ name: "Malaysia", iso2: "my", dialCode: "60", minLength: 9, maxLength: 10 },
{ name: "Malta", iso2: "mt", dialCode: "356", minLength: 7, maxLength: 8 },
{ name: "Mexico", iso2: "mx", dialCode: "52", minLength: 10, maxLength: 10 },
{ name: "Nepal", iso2: "np", dialCode: "977", minLength: 10, maxLength: 10 },
{ name: "Netherlands", iso2: "nl", dialCode: "31", minLength: 9, maxLength: 9 },
{ name: "New Zealand", iso2: "nz", dialCode: "64", minLength: 8, maxLength: 9 },
{ name: "Nigeria", iso2: "ng", dialCode: "234", minLength: 10, maxLength: 11 },
{ name: "Norway", iso2: "no", dialCode: "47", minLength: 8, maxLength: 8 },
{ name: "Oman", iso2: "om", dialCode: "968", minLength: null, maxLength: null },

{ name: "Pakistan", iso2: "pk", dialCode: "92", minLength: 10, maxLength: 10 },
{ name: "Philippines", iso2: "ph", dialCode: "63", minLength: 10, maxLength: 10 },
{ name: "Poland", iso2: "pl", dialCode: "48", minLength: 9, maxLength: 9 },
{ name: "Portugal", iso2: "pt", dialCode: "351", minLength: 9, maxLength: 9 },
{ name: "Qatar", iso2: "qa", dialCode: "974", minLength: 8, maxLength: 8 },
{ name: "Romania", iso2: "ro", dialCode: "40", minLength: 9, maxLength: 9 },
{ name: "Russia", iso2: "ru", dialCode: "7", minLength: 10, maxLength: 10 },

{ name: "Saudi Arabia", iso2: "sa", dialCode: "966", minLength: 9, maxLength: 9 },
{ name: "Singapore", iso2: "sg", dialCode: "65", minLength: 8, maxLength: 8 },
{ name: "Slovakia", iso2: "sk", dialCode: "421", minLength: 9, maxLength: 13 },
{ name: "Slovenia", iso2: "si", dialCode: "386", minLength: 8, maxLength: 9 },
{ name: "South Africa", iso2: "za", dialCode: "27", minLength: 9, maxLength: 9 },
{ name: "South Korea", iso2: "kr", dialCode: "82", minLength: 10, maxLength: 11 },
{ name: "Spain", iso2: "es", dialCode: "34", minLength: 9, maxLength: 9 },
{ name: "Sri Lanka", iso2: "lk", dialCode: "94", minLength: 9, maxLength: 9 },
{ name: "Sweden", iso2: "se", dialCode: "46", minLength: 9, maxLength: 9 },
{ name: "Switzerland", iso2: "ch", dialCode: "41", minLength: 9, maxLength: 9 },

{ name: "Thailand", iso2: "th", dialCode: "66", minLength: 9, maxLength: 9 },
{ name: "Turkey", iso2: "tr", dialCode: "90", minLength: 10, maxLength: 10 },
{ name: "Ukraine", iso2: "ua", dialCode: "380", minLength: 9, maxLength: 9 },
{ name: "United Arab Emirates", iso2: "ae", dialCode: "971", minLength: 9, maxLength: 9 },
{ name: "United Kingdom", iso2: "gb", dialCode: "44", minLength: 10, maxLength: 10 },
{ name: "United States", iso2: "us", dialCode: "1", minLength: 10, maxLength: 10 },
{ name: "Vietnam", iso2: "vn", dialCode: "84", minLength: 9, maxLength: 10 }
];

export default countries;